(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("modelIoClient", [], factory);
	else if(typeof exports === 'object')
		exports["modelIoClient"] = factory();
	else
		root["modelIoClient"] = factory();
})(this, function() {
return 